module.exports = __webpack_public_path__ + "static/img/title.6ea10cb.png";


//////////////////
// WEBPACK FOOTER
// ./static/en/img/feature6/title.png
// module id = vPfm
// module chunks = 7